import axiosInstance from "../interceptors";

const DEFAULT_PAGE = 0;
const DEFAULT_SIZE = 10;

const EMPTY_PAGE = {
  content: [],
  page: DEFAULT_PAGE,
  size: DEFAULT_SIZE,
  totalElements: 0,
  totalPages: 0,
};

export const fetchSuggestedCandidates = async (
  jobId,
  _form,
  { page = DEFAULT_PAGE, size = DEFAULT_SIZE } = {},
) => {
  if (!jobId) return { ...EMPTY_PAGE, page, size };

  try {
    const response = await axiosInstance.get(
      `/ai/suggestions/jobs/${jobId}/candidates`,
      { params: { page, size } },
    );
    const data = response?.data || {};
    return {
      content: Array.isArray(data.content) ? data.content : [],
      page: typeof data.page === "number" ? data.page : page,
      size: typeof data.size === "number" ? data.size : size,
      totalElements:
        typeof data.totalElements === "number" ? data.totalElements : 0,
      totalPages: typeof data.totalPages === "number" ? data.totalPages : 0,
    };
  } catch (_err) {
    return { ...EMPTY_PAGE, page, size };
  }
};

export default fetchSuggestedCandidates;
